import { render } from "./ModelCoordinator.vue?vue&type=template&id=723710e3&scoped=true"
import script from "./ModelCoordinator.vue?vue&type=script&lang=js"
export * from "./ModelCoordinator.vue?vue&type=script&lang=js"

import "./ModelCoordinator.vue?vue&type=style&index=0&id=723710e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723710e3"]])

export default __exports__